import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ChevronRight, Loader2, ArrowRight } from "lucide-react";
import api from "../lib/api";
import LeadForm from "../components/site/LeadForm";
import NotFound from "./NotFound";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/blog/${slug}`)
      .then((r) => { setPost(r.data); document.title = r.data.seo_title || r.data.title; })
      .catch(() => setPost(false))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="container-site py-24 flex justify-center"><Loader2 className="animate-spin text-brand-red" size={32} /></div>;
  if (!post) return <NotFound />;

  return (
    <div data-testid="blog-detail-page" className="container-site py-12 lg:py-16">
      <nav className="flex items-center gap-1.5 text-xs text-brand-muted mb-8" aria-label="Breadcrumb">
        <Link to="/" className="hover:text-brand-dark">Home</Link><ChevronRight size={12} />
        <Link to="/blog" className="hover:text-brand-dark">Blog</Link><ChevronRight size={12} />
        <span className="text-brand-dark font-semibold truncate max-w-[200px] sm:max-w-none">{post.title}</span>
      </nav>

      <article className="max-w-3xl mx-auto">
        <span className="text-[10px] uppercase tracking-[0.18em] font-bold text-brand-red">{post.category}</span>
        <h1 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-[1.1] text-brand-dark" data-testid="blog-title">{post.title}</h1>
        <p className="mt-4 text-sm text-brand-muted font-semibold">{post.author} · {post.read_time} · {new Date(post.published_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</p>
        <img src={post.image} alt={post.title} className="mt-8 rounded-3xl w-full h-[280px] sm:h-[400px] object-cover" data-testid="blog-image" />
        <div className="mt-10 space-y-5" data-testid="blog-content">
          {(post.content || "").split("\n\n").map((para, i) => (
            <p key={i} className="text-base text-brand-dark/80 leading-relaxed">{para}</p>
          ))}
        </div>
        <div className="mt-8 flex flex-wrap gap-2">
          {(post.tags || []).map((t) => (
            <span key={t} className="rounded-full bg-white border border-black/10 px-3.5 py-1.5 text-xs font-semibold text-brand-muted">{t}</span>
          ))}
        </div>
        <div className="mt-12 rounded-3xl bg-brand-dark text-white p-8 sm:p-10 text-center">
          <h2 className="font-heading text-2xl sm:text-3xl font-extrabold">Thinking About a Loan?</h2>
          <p className="mt-3 text-sm text-white/60 max-w-md mx-auto">Get an indicative eligibility estimate in 30 seconds, then talk to a real advisor.</p>
          <Link to="/calculators/eligibility" data-testid="blog-eligibility-btn" className="btn-primary mt-6">Check Eligibility <ArrowRight size={15} /></Link>
        </div>
      </article>

      <div className="max-w-3xl mx-auto mt-12">
        <LeadForm compact source={`blog_${post.slug}`} title="Have a question about your loan options?" />
      </div>
    </div>
  );
}
